const AppRoutePath = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",

  USERS: "/users",
  USERS_EMPLOYEE: "/users/employee",
  USERS_ADD_EMPLOYEE: "/users/add_employee",
  USERS_EDIT_EMPLOYEE: "/users/edit_employee/:id",
  USERS_VIEW_EMPLOYEE: "/view_employee/:id",
  USERS_JABATAN: "/users/jabatan",
  USERS_OUTLET: "/users/outlet",
  USERS_LIST_USER: "/users/list_users",
  STORAGE: "/storage/list_storage",
  STORAGE_ADD_STORAGE: "/storage/add_storage",
  STORAGE_EDIT_STORAGE: "/storage/edit_storage",
  SHELF: "/shelf/list_shelf",
  SHELF_ADD_SHELF: "/shelf/add_shelf",
  SHELF_EDIT_SHELF: "/shelf/edit_shelf",
  PRODUCT_CATEGORY: "/product-category/list_product_category",
  PRODUCT_CATEGORY_ADD_PRODUCT_CATEGORY:
    "/product-category/add_product_category",
  PRODUCT_CATEGORY_EDIT_PRODUCT_CATEGORY:
    "/product-category/edit_product_category",
  LABEL: "/label/list_label",
  LABEL_ADD_LABEL: "/label/add_label",
  LABEL_EDIT_LABEL: "/label/edit_label",
  POINT_WITHDRAWAL: "/point-withdrawal/list_point_withdrawal",
  POINT_WITHDRAWAL_ADD_POINT_WITHDRAWAL:
    "/point-withdrawal/add_point_withdrawal",
  POINT_WITHDRAWAL_EDIT_POINT_WITHDRAWAL:
    "/point-withdrawal/edit_point_withdrawal",
  OUTLET_DEBIT_CARD: "/outlet-debit-card/list_outlet_debit_card",
  OUTLET_DEBIT_CARD_ADD_OUTLET_DEBIT_CARD:
    "/outlet-debit-card/add_outlet_debit_card",
  OUTLET_DEBIT_CARD_EDIT_OUTLET_DEBIT_CARD:
    "/outlet-debit-card/edit_outlet_debit_card",
  ROLE: "/role/list_role",
  ROLE_ADD_ROLE: "/role/add_role",
  ROLE_EDIT_ROLE: "/role/edit_role/:id",
  TASK_DAILY_TASK: "/tasks",
  TASK_REPORT_DAILY_TASK: "/tasks_report",
  PAWN_TRANSACTION: "/history/pawn",
  CAPITAL_CASH_TRANSACTION: "/history/capital-cash",
  REFUND_REPORT: "/refund/list",
  REFUND_REQUEST: "/refund/request",
  REFUND_EXPIRED: "/refund/expired",
  PAWN_TRANSACTION_REPORT: "/report/pawn",
  PAWN_TRANSACTION_REPORT_DETAIL: "/report/pawn/:id",
  FAILED_REDEEM_REPORT: "/report/failed-redeem",
  CAMPAIGN: "/campaign/list",
  CAMPAIGN_DEFAULT: "/campaign-default/list",
  CAMPAIGN_LOAN_ADD: "/campaign/add-campaign-loan",
  CAMPAIGN_LOAN_EDIT: "/campaign/edit-campaign-loan",
  CAMPAIGN_LOAN_ADD_DEFAULT: "/campaign-default/add-campaign-loan",
  CAMPAIGN_LOAN_EDIT_DEFAULT: "/campaign-default/edit-campaign-loan",
  CAMPAIGN_INSTALLMENT_ADD: "/campaign-default/add-campaign-installment",
  CAMPAIGN_INSTALLMENT_ADD_OFFER: "/campaign/add-campaign-installment",

  MIDTRANS_APPROVAL: "/midtrans-approval",
  TOPUP_DEPOSIT: "/topup-deposit",
  LOAN_NONCASH: "/loan-noncash",
  PAYMENT_NONCASH: "/payment-noncash",
  CUSTOMER: "/customers",
  CUSTOMER_DETAIL: "/customer/:id",
  CAPITAL_CASH_OUTLET: "/capital-cash-outlet",
  CAMPAIGN_EXTENSION_ADD_DEFAULT: "/campaign-default/add-campaign-extension",
  CAMPAIGN_EXTENSION_EDIT_DEFAULT: "/campaign-default/edit-campaign-extension",
  CAMPAIGN_EXTENSION_ADD: "/campaign/add-campaign-extension",
  CAMPAIGN_EXTENSION_EDIT: "/campaign/edit-campaign-extension",
  SBG_PRIVATE: "/sbg-private/:id",
  SBG_PUBLIC: "/sbg-public/:hash",
  SBG_VALUATOR: "/sbg-public-valuator/:hash",
  PRINT_NOTA_PAWN_TRANSACTION: "/history/pawn/print-nota/:id",
  PRINT_NOTA_CAPITAL_TRANSACTION: "/history/capital-cash/print-nota/:id",
  EXPORT_PDF_PAWN_TRANSACTION: "/history/pawn/export",
  EXPORT_PDF_CAPITAL_TRANSACTION: "/history/capital/export",
  EXPORT_PDF_CASH_TRANSACTION: "/history/cash/export",
  EXPORT_PDF_PAWN_REPORT: "/report/pawn/export",
  EXPORT_PDF_REFUND_REPORT: "/refund/export",
  EXPORT_PDF_FAILED_REDEEM_REPORT: "/report/failed-redeem/export",
  PROCESS_LOAN_NONCASH: "/loan-noncash/:id",
  LIST_PRODUCT: "/product-category/:code_product",
  UPLOAD_PRODUCT: "/product-category/upload-product/:code_product",
  RESET_PASSWORD: "/reset_password",

  AREA_LIST: "/area/area-list",
  ADD_AREA_LIST: "/area/add-area",
  EDIT_AREA_LIST: "/area/edit-area/:id",
  PERMOHONAN_JEMPUT_GADAI: "/permohonan-jemput_gadai",
  JEMPUT_GADAI_TERJADWAL: "/jemput-gadai-terjadwal",
  PERMOHONAN_PENGEMBALIAN_BARANG: "/permohonan-pengembalian-barang",
  PENGEMBALIAN_TERJADWAL: "/pengembalian-terjadwal",
  HISTORY_TERJADWAL: "/history-pengembalian",
  APPRAISER_LIST: "/appraiser",
  APPRAISER_LIST_BY_OUTLET: "/appraiser-by-outlet",
  APPRAISER_ADD_BY_OUTLET: "/appraiser-by-outlet/add",
  APPRAISER_EDIT_BY_OUTLET: "/appraiser-by-outlet/edit/:id",

  EXCLUSIVE_LIST: "/exclusive",
  EXCLUSIVE_ADD: "/exclusive/add",
  COMPANY_SETTING: "/company-setting",
  COMMISSION_DISBURSEMENT: "/commissions-disbursement",
  MEMBERSHIP_SETTING: "/membership-setting",
  BANK_LIST: "/banks",
  NOTIFICATION_SETTING: "/notification-setting",
  ADD_NOTIFICATION: "/add-notification-setting",
  EDIT_NOTIFICATION: "/edit-notification-setting/:id",
  EXPORT_PDF_CUSTOMER: "/report/customer/export",
  EXPORT_PDF_PAWN: "/report/pawn-list/export",
  REDEEM: "/redeem",
  VOUCHER: "/voucher",
};

export default AppRoutePath;
